import { SavedArtworkPageModel } from './savedArtworkPage'

export type SavedArtworkModel = {
  cache_key: number,
  agency_id: number,
  data?: any,
  first_page?: SavedArtworkPageModel,
  id: number,
  pages_count?: number,
  title: string,
  type: string,
  user_id:number,
}

export type SavedArtworkRequestOptions = {}

const state = {
  agency_id: null,
  id: null,
  title: '',
}

export const requiredFields = [
  { key: 'agency_id' },
  { key: 'title' },
]

export default state
